import { Card, CardContent, CardHeader, Typography, makeStyles } from '@material-ui/core';
import { LinkButton } from '@backstage/core-components';
import { CompoundEntityRef } from '@backstage/catalog-model';

export type PavedPathCardProps = {
  title: string;
  imageUrl?: string;
  description: string;
  location: CompoundEntityRef | string;
};

const useStyles = makeStyles(() => ({
  root: {
    color: '#FFF',
    borderRadius: '16px',
    backgroundColor: 'rgb(217, 34, 40)',
  },
  header: {
    flex: '0 1 auto',
    marginRight: '20px',
  },
  action: {
    marginTop: '0px',
  },
  link: {
    borderColor: '#FFF',
    color: '#FFF',
  },
}));

export default function PavePathsOnboardingChecklist() {
  const classes = useStyles();
  const linkUrl = '/docs/default/component/developer-portal-web/paved-paths/onboarding-checklist';

  return (
    <Card className={classes.root} title="Platform Paved Paths Onboarding Checklist">
      <CardHeader
        classes={{ content: classes.header, action: classes.action }}
        title="Platform Paved Paths Onboarding Checklist"
        action={
          <LinkButton className={classes.link} to={linkUrl} variant="outlined">
            Learn more
          </LinkButton>
        }
      />
      <CardContent>
        <Typography paragraph>
          Discover the Platform Paved Path at Realtor – a revolutionary approach streamlining project development. By
          providing a clear, standardized framework, it accelerates delivery, ensures quality, and simplifies
          onboarding, making it a game-changer for teams aiming to redefine how they build. 🚀
        </Typography>
        <Typography paragraph>
          Learn more about this transformative solution for efficient, secure, and reliable feature delivery at Realtor.
        </Typography>
      </CardContent>
    </Card>
  );
}
